// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f58a3291b812a30a4d79","655":"7876019b45e2fd1b67c8"}[chunkId] + ".js";
};